import { useState, useRef, useContext } from "react"
// my imports:
import OneOffHint from "@/app/components/OneOffHint"
import UI from "@/app/lib/ui/ui";
import { Contexts } from "@/app/components/Context";

export default function IngredientsTitle() {

    const ui: UI | null = useContext(Contexts.UI);
    if (!ui) {
        console.warn("bad context in IngredientsTitle component");
        return null;
    }

    const element = ui.ingredientRefs.current?.[2] ?? null;

    const [isShowingHint, setIsShowingHint] = useState(false);
    function toggleHint() {
        setIsShowingHint(!isShowingHint);
    }

    const hintText: string = `These letters are the "ingredients." You use them to fill in empty boxes. You can use each as many times as you'd like, and you don't have to use them all.`

    return(
        <>
        {isShowingHint && element !== null &&
            <OneOffHint
                element={element}
                elementOffset={{x: 0, y: 5}}
                text={hintText}
                linkText="Dismiss"
                setShowing={setIsShowingHint}
            />
        }
        <div
            tabIndex={0}
            onClick={(e) => {
                e.stopPropagation();
                toggleHint();
            }}
            onBlur={() => setIsShowingHint(false)}
        >
            <h2 className='title textAsButton'>
                ingredients:
            </h2>
        </div>
        </>
    )
}